module.exports = __webpack_public_path__ + "static/n-4402ad408b6c785b27c82581b8e2920e.jpg";